const onlyLatinLetters = () => {
  const inputElements = document.querySelectorAll(`.js-only-latin`);

  if (inputElements.length) {
    inputElements.forEach((inputElement) => {
      inputElement.addEventListener(`input`, () => {
        inputElement.value = inputElement.value.replace(/[А-Яа-я]/g, "");
      });
    });
  }
};

export {onlyLatinLetters};
